module.exports = __webpack_public_path__ + "static/media/completed.7556eaf2.svg";